import gql from 'graphql-tag'

export const GET_CHANNEX_STATUS_QUERY = gql`
  query GetChannexStatus {
    getChannexStatus {
      configured
      enabled
      apiReachable
      propertyTitle
      apiError
      webhookSecretSet
      pendingOutbox
      errorOutbox
      mappedRoomTypes
      mappedRatePlans
      lastFullSyncAt
    }
  }
`
